const actions = {
  // User-side
  LOAD_BILLING_PROFILE_REQUEST: 'MEAGENDA_BILLING_LOAD_PROFILE_REQUEST',
  BILLING_PROFILE_UPDATED: 'MEAGENDA_BILLING_PROFILE_UPDATED',
  BILLING_PROFILE_NOT_FOUND: 'MEAGENDA_BILLING_PROFILE_NOT_FOUND',
  BILLING_PROFILE_ERROR: 'MEAGENDA_BILLING_PROFILE_ERROR',
  BILLING_INVOICES_UPDATED: 'MEAGENDA_BILLING_INVOICES_UPDATED',

  ACTIVATE_TRIAL_REQUEST: 'MEAGENDA_BILLING_ACTIVATE_TRIAL_REQUEST',
  ACTIVATE_TRIAL_SUCCESS: 'MEAGENDA_BILLING_ACTIVATE_TRIAL_SUCCESS',
  ACTIVATE_TRIAL_ERROR: 'MEAGENDA_BILLING_ACTIVATE_TRIAL_ERROR',

  CREATE_PROFILE_REQUEST: 'MEAGENDA_BILLING_CREATE_PROFILE_REQUEST',
  CREATE_PROFILE_SUCCESS: 'MEAGENDA_BILLING_CREATE_PROFILE_SUCCESS',
  CREATE_PROFILE_ERROR: 'MEAGENDA_BILLING_CREATE_PROFILE_ERROR',

  // Admin-side
  ADMIN_SEARCH_PROFILES_REQUEST: 'MEAGENDA_BILLING_ADMIN_SEARCH_REQUEST',
  ADMIN_SEARCH_PROFILES_SUCCESS: 'MEAGENDA_BILLING_ADMIN_SEARCH_SUCCESS',
  ADMIN_SEARCH_PROFILES_ERROR: 'MEAGENDA_BILLING_ADMIN_SEARCH_ERROR',
  ADMIN_CLEAR_SEARCH: 'MEAGENDA_BILLING_ADMIN_CLEAR_SEARCH',

  ADMIN_LOAD_PROFILES_BY_PAYER_REQUEST: 'MEAGENDA_BILLING_ADMIN_LOAD_BY_PAYER_REQUEST',
  ADMIN_LOAD_PROFILES_BY_PAYER_SUCCESS: 'MEAGENDA_BILLING_ADMIN_LOAD_BY_PAYER_SUCCESS',
  ADMIN_LOAD_PROFILES_BY_PAYER_ERROR: 'MEAGENDA_BILLING_ADMIN_LOAD_BY_PAYER_ERROR',
  ADMIN_CLEAR_PAYER: 'MEAGENDA_BILLING_ADMIN_CLEAR_PAYER',

  ADMIN_LINK_PROFILE_REQUEST: 'MEAGENDA_BILLING_ADMIN_LINK_REQUEST',
  ADMIN_LINK_PROFILE_SUCCESS: 'MEAGENDA_BILLING_ADMIN_LINK_SUCCESS',
  ADMIN_LINK_PROFILE_ERROR: 'MEAGENDA_BILLING_ADMIN_LINK_ERROR',

  ADMIN_CANCEL_PROFILE_REQUEST: 'MEAGENDA_BILLING_ADMIN_CANCEL_REQUEST',
  ADMIN_CANCEL_PROFILE_SUCCESS: 'MEAGENDA_BILLING_ADMIN_CANCEL_SUCCESS',
  ADMIN_CANCEL_PROFILE_ERROR: 'MEAGENDA_BILLING_ADMIN_CANCEL_ERROR',

  ADMIN_SUSPEND_PROFILE_REQUEST: 'MEAGENDA_BILLING_ADMIN_SUSPEND_REQUEST',
  ADMIN_SUSPEND_PROFILE_SUCCESS: 'MEAGENDA_BILLING_ADMIN_SUSPEND_SUCCESS',
  ADMIN_SUSPEND_PROFILE_ERROR: 'MEAGENDA_BILLING_ADMIN_SUSPEND_ERROR',

  ADMIN_REACTIVATE_PROFILE_REQUEST: 'MEAGENDA_BILLING_ADMIN_REACTIVATE_REQUEST',
  ADMIN_REACTIVATE_PROFILE_SUCCESS: 'MEAGENDA_BILLING_ADMIN_REACTIVATE_SUCCESS',
  ADMIN_REACTIVATE_PROFILE_ERROR: 'MEAGENDA_BILLING_ADMIN_REACTIVATE_ERROR',

  ADMIN_MOVE_UID_REQUEST: 'MEAGENDA_BILLING_ADMIN_MOVE_UID_REQUEST',
  ADMIN_MOVE_UID_SUCCESS: 'MEAGENDA_BILLING_ADMIN_MOVE_UID_SUCCESS',
  ADMIN_MOVE_UID_ERROR: 'MEAGENDA_BILLING_ADMIN_MOVE_UID_ERROR',

  ADMIN_LIST_ASAAS_SUBS_REQUEST: 'MEAGENDA_BILLING_ADMIN_LIST_ASAAS_SUBS_REQUEST',
  ADMIN_LIST_ASAAS_SUBS_SUCCESS: 'MEAGENDA_BILLING_ADMIN_LIST_ASAAS_SUBS_SUCCESS',
  ADMIN_LIST_ASAAS_SUBS_ERROR: 'MEAGENDA_BILLING_ADMIN_LIST_ASAAS_SUBS_ERROR',
  ADMIN_LIST_ASAAS_SUBS_CLEAR: 'MEAGENDA_BILLING_ADMIN_LIST_ASAAS_SUBS_CLEAR',

  ADMIN_LOAD_PAYER_HPS_REQUEST: 'MEAGENDA_BILLING_ADMIN_LOAD_PAYER_HPS_REQUEST',
  ADMIN_LOAD_PAYER_HPS_SUCCESS: 'MEAGENDA_BILLING_ADMIN_LOAD_PAYER_HPS_SUCCESS',
  ADMIN_LOAD_PAYER_HPS_ERROR: 'MEAGENDA_BILLING_ADMIN_LOAD_PAYER_HPS_ERROR',
  ADMIN_CLEAR_PAYER_HPS: 'MEAGENDA_BILLING_ADMIN_CLEAR_PAYER_HPS',

  ADMIN_SET_COVERED_UIDS_REQUEST: 'MEAGENDA_BILLING_ADMIN_SET_COVERED_UIDS_REQUEST',
  ADMIN_SET_COVERED_UIDS_SUCCESS: 'MEAGENDA_BILLING_ADMIN_SET_COVERED_UIDS_SUCCESS',
  ADMIN_SET_COVERED_UIDS_ERROR: 'MEAGENDA_BILLING_ADMIN_SET_COVERED_UIDS_ERROR',

  ADMIN_RECOMPUTE_PROFILE_REQUEST: 'MEAGENDA_BILLING_ADMIN_RECOMPUTE_REQUEST',
  ADMIN_RECOMPUTE_PROFILE_SUCCESS: 'MEAGENDA_BILLING_ADMIN_RECOMPUTE_SUCCESS',
  ADMIN_RECOMPUTE_PROFILE_ERROR: 'MEAGENDA_BILLING_ADMIN_RECOMPUTE_ERROR',

  ADMIN_SET_PROFILE_MODE_REQUEST: 'MEAGENDA_BILLING_ADMIN_SET_MODE_REQUEST',
  ADMIN_SET_PROFILE_MODE_SUCCESS: 'MEAGENDA_BILLING_ADMIN_SET_MODE_SUCCESS',
  ADMIN_SET_PROFILE_MODE_ERROR: 'MEAGENDA_BILLING_ADMIN_SET_MODE_ERROR',

  ADMIN_SET_TRIAL_REQUEST: 'MEAGENDA_BILLING_ADMIN_SET_TRIAL_REQUEST',
  ADMIN_SET_TRIAL_SUCCESS: 'MEAGENDA_BILLING_ADMIN_SET_TRIAL_SUCCESS',
  ADMIN_SET_TRIAL_ERROR: 'MEAGENDA_BILLING_ADMIN_SET_TRIAL_ERROR',

  ADMIN_FORCE_PRORATA_MERGE_REQUEST: 'MEAGENDA_BILLING_ADMIN_FORCE_PRORATA_REQUEST',
  ADMIN_FORCE_PRORATA_MERGE_SUCCESS: 'MEAGENDA_BILLING_ADMIN_FORCE_PRORATA_SUCCESS',
  ADMIN_FORCE_PRORATA_MERGE_ERROR: 'MEAGENDA_BILLING_ADMIN_FORCE_PRORATA_ERROR',

  ADMIN_FORGIVE_PRORATA_REQUEST: 'MEAGENDA_BILLING_ADMIN_FORGIVE_PRORATA_REQUEST',
  ADMIN_FORGIVE_PRORATA_SUCCESS: 'MEAGENDA_BILLING_ADMIN_FORGIVE_PRORATA_SUCCESS',
  ADMIN_FORGIVE_PRORATA_ERROR: 'MEAGENDA_BILLING_ADMIN_FORGIVE_PRORATA_ERROR',

  ADMIN_APPLY_COURTESY_REQUEST: 'MEAGENDA_BILLING_ADMIN_APPLY_COURTESY_REQUEST',
  ADMIN_APPLY_COURTESY_SUCCESS: 'MEAGENDA_BILLING_ADMIN_APPLY_COURTESY_SUCCESS',
  ADMIN_APPLY_COURTESY_ERROR: 'MEAGENDA_BILLING_ADMIN_APPLY_COURTESY_ERROR',

  ADMIN_LOAD_CURRENT_INVOICE_REQUEST: 'MEAGENDA_BILLING_ADMIN_LOAD_CURRENT_INVOICE_REQUEST',
  ADMIN_LOAD_CURRENT_INVOICE_SUCCESS: 'MEAGENDA_BILLING_ADMIN_LOAD_CURRENT_INVOICE_SUCCESS',
  ADMIN_LOAD_CURRENT_INVOICE_ERROR: 'MEAGENDA_BILLING_ADMIN_LOAD_CURRENT_INVOICE_ERROR',
  ADMIN_CLEAR_CURRENT_INVOICES: 'MEAGENDA_BILLING_ADMIN_CLEAR_CURRENT_INVOICES',

  ADMIN_SEARCH_ASAAS_CUSTOMERS_REQUEST: 'MEAGENDA_BILLING_ADMIN_SEARCH_ASAAS_CUSTOMERS_REQUEST',
  ADMIN_SEARCH_ASAAS_CUSTOMERS_SUCCESS: 'MEAGENDA_BILLING_ADMIN_SEARCH_ASAAS_CUSTOMERS_SUCCESS',
  ADMIN_SEARCH_ASAAS_CUSTOMERS_ERROR: 'MEAGENDA_BILLING_ADMIN_SEARCH_ASAAS_CUSTOMERS_ERROR',
  ADMIN_CLEAR_ASAAS_CUSTOMERS_SEARCH: 'MEAGENDA_BILLING_ADMIN_CLEAR_ASAAS_CUSTOMERS_SEARCH',

  ADMIN_LOAD_QUEUE_COUNTS_REQUEST: 'MEAGENDA_BILLING_ADMIN_LOAD_QUEUE_COUNTS_REQUEST',
  ADMIN_LOAD_QUEUE_COUNTS_SUCCESS: 'MEAGENDA_BILLING_ADMIN_LOAD_QUEUE_COUNTS_SUCCESS',
  ADMIN_LOAD_QUEUE_COUNTS_ERROR: 'MEAGENDA_BILLING_ADMIN_LOAD_QUEUE_COUNTS_ERROR',

  ADMIN_LOAD_QUEUE_REQUEST: 'MEAGENDA_BILLING_ADMIN_LOAD_QUEUE_REQUEST',
  ADMIN_LOAD_QUEUE_SUCCESS: 'MEAGENDA_BILLING_ADMIN_LOAD_QUEUE_SUCCESS',
  ADMIN_LOAD_QUEUE_ERROR: 'MEAGENDA_BILLING_ADMIN_LOAD_QUEUE_ERROR',
  ADMIN_CLEAR_QUEUE: 'MEAGENDA_BILLING_ADMIN_CLEAR_QUEUE',

  ADMIN_LEGACY_MATCH_REQUEST: 'MEAGENDA_BILLING_ADMIN_LEGACY_MATCH_REQUEST',
  ADMIN_LEGACY_MATCH_SUCCESS: 'MEAGENDA_BILLING_ADMIN_LEGACY_MATCH_SUCCESS',
  ADMIN_LEGACY_MATCH_ERROR: 'MEAGENDA_BILLING_ADMIN_LEGACY_MATCH_ERROR',

  ADMIN_LEGACY_LOOKUP_REQUEST: 'MEAGENDA_BILLING_ADMIN_LEGACY_LOOKUP_REQUEST',
  ADMIN_LEGACY_LOOKUP_SUCCESS: 'MEAGENDA_BILLING_ADMIN_LEGACY_LOOKUP_SUCCESS',
  ADMIN_LEGACY_LOOKUP_ERROR: 'MEAGENDA_BILLING_ADMIN_LEGACY_LOOKUP_ERROR',

  ADMIN_PREVIEW_MIGRATION_REQUEST: 'MEAGENDA_BILLING_ADMIN_PREVIEW_MIGRATION_REQUEST',
  ADMIN_PREVIEW_MIGRATION_SUCCESS: 'MEAGENDA_BILLING_ADMIN_PREVIEW_MIGRATION_SUCCESS',
  ADMIN_PREVIEW_MIGRATION_ERROR: 'MEAGENDA_BILLING_ADMIN_PREVIEW_MIGRATION_ERROR',
  ADMIN_CLEAR_PREVIEW_MIGRATION: 'MEAGENDA_BILLING_ADMIN_CLEAR_PREVIEW_MIGRATION',

  ADMIN_MIGRATE_PROFILE_REQUEST: 'MEAGENDA_BILLING_ADMIN_MIGRATE_PROFILE_REQUEST',
  ADMIN_MIGRATE_PROFILE_SUCCESS: 'MEAGENDA_BILLING_ADMIN_MIGRATE_PROFILE_SUCCESS',
  ADMIN_MIGRATE_PROFILE_ERROR: 'MEAGENDA_BILLING_ADMIN_MIGRATE_PROFILE_ERROR',
  ADMIN_CLEAR_MIGRATION_RESULT: 'MEAGENDA_BILLING_ADMIN_CLEAR_MIGRATION_RESULT',

  ADMIN_LOAD_PROFILE_HISTORY_REQUEST: 'MEAGENDA_BILLING_ADMIN_LOAD_PROFILE_HISTORY_REQUEST',
  ADMIN_LOAD_PROFILE_HISTORY_SUCCESS: 'MEAGENDA_BILLING_ADMIN_LOAD_PROFILE_HISTORY_SUCCESS',
  ADMIN_LOAD_PROFILE_HISTORY_ERROR: 'MEAGENDA_BILLING_ADMIN_LOAD_PROFILE_HISTORY_ERROR',

  ADMIN_LIST_UNLINKED_REQUEST: 'MEAGENDA_BILLING_ADMIN_LIST_UNLINKED_REQUEST',
  ADMIN_LIST_UNLINKED_SUCCESS: 'MEAGENDA_BILLING_ADMIN_LIST_UNLINKED_SUCCESS',
  ADMIN_LIST_UNLINKED_ERROR: 'MEAGENDA_BILLING_ADMIN_LIST_UNLINKED_ERROR',
  ADMIN_LIST_UNLINKED_CLEAR: 'MEAGENDA_BILLING_ADMIN_LIST_UNLINKED_CLEAR',

  loadBillingProfile: () => ({
    type: actions.LOAD_BILLING_PROFILE_REQUEST,
  }),
  activateTrial: ({ cpfCnpj, mobilePhone, email } = {}) => ({
    type: actions.ACTIVATE_TRIAL_REQUEST,
    payload: { cpfCnpj, mobilePhone, email },
  }),
  createProfile: ({ payerUid, coveredUids } = {}) => ({
    type: actions.CREATE_PROFILE_REQUEST,
    payload: { payerUid, coveredUids },
  }),
  // Admin
  adminSearchBillingProfiles: (term) => ({
    type: actions.ADMIN_SEARCH_PROFILES_REQUEST,
    payload: { term },
  }),
  adminClearBillingSearch: () => ({
    type: actions.ADMIN_CLEAR_SEARCH,
  }),
  adminLoadProfilesByPayer: (payerUid) => ({
    type: actions.ADMIN_LOAD_PROFILES_BY_PAYER_REQUEST,
    payload: { payerUid },
  }),
  adminClearBillingPayer: () => ({
    type: actions.ADMIN_CLEAR_PAYER,
  }),
  adminLinkProfile: (payload) => ({
    type: actions.ADMIN_LINK_PROFILE_REQUEST,
    payload,
  }),
  adminCancelProfile: (profileId) => ({
    type: actions.ADMIN_CANCEL_PROFILE_REQUEST,
    payload: { profileId },
  }),
  adminSuspendProfile: (profileId) => ({
    type: actions.ADMIN_SUSPEND_PROFILE_REQUEST,
    payload: { profileId },
  }),
  adminReactivateProfile: (profileId) => ({
    type: actions.ADMIN_REACTIVATE_PROFILE_REQUEST,
    payload: { profileId },
  }),
  adminMoveUid: (payload) => ({
    type: actions.ADMIN_MOVE_UID_REQUEST,
    payload,
  }),
  adminListAsaasSubscriptions: ({
    payerUid, offset, limit, status, ignorePayerCustomer, explicitCustomerId,
  } = {}) => ({
    type: actions.ADMIN_LIST_ASAAS_SUBS_REQUEST,
    payload: {
      payerUid, offset, limit, status, ignorePayerCustomer, explicitCustomerId,
    },
  }),
  adminClearAsaasSubscriptions: () => ({
    type: actions.ADMIN_LIST_ASAAS_SUBS_CLEAR,
  }),
  adminLoadPayerHps: (payerUid) => ({
    type: actions.ADMIN_LOAD_PAYER_HPS_REQUEST,
    payload: { payerUid },
  }),
  adminClearPayerHps: () => ({
    type: actions.ADMIN_CLEAR_PAYER_HPS,
  }),
  adminSetCoveredUids: ({ profileId, coveredUids }) => ({
    type: actions.ADMIN_SET_COVERED_UIDS_REQUEST,
    payload: { profileId, coveredUids },
  }),
  adminRecomputeProfile: (profileId, { syncOpenInvoice } = {}) => ({
    type: actions.ADMIN_RECOMPUTE_PROFILE_REQUEST,
    payload: { profileId, syncOpenInvoice },
  }),
  adminSetProfileMode: ({ profileId, mode }) => ({
    type: actions.ADMIN_SET_PROFILE_MODE_REQUEST,
    payload: { profileId, mode },
  }),
  adminSetTrial: ({ profileId, trialUntil }) => ({
    type: actions.ADMIN_SET_TRIAL_REQUEST,
    payload: { profileId, trialUntil },
  }),
  adminForceProrataMerge: (profileId) => ({
    type: actions.ADMIN_FORCE_PRORATA_MERGE_REQUEST,
    payload: { profileId },
  }),
  adminForgiveProrata: ({ profileId, reason }) => ({
    type: actions.ADMIN_FORGIVE_PRORATA_REQUEST,
    payload: { profileId, reason },
  }),
  adminApplyCourtesy: (payload) => ({
    type: actions.ADMIN_APPLY_COURTESY_REQUEST,
    payload,
  }),
  adminLoadQueueCounts: () => ({
    type: actions.ADMIN_LOAD_QUEUE_COUNTS_REQUEST,
  }),
  adminLoadQueue: ({ queue, status, cursor } = {}) => ({
    type: actions.ADMIN_LOAD_QUEUE_REQUEST,
    payload: { queue, status, cursor },
  }),
  adminClearQueue: () => ({
    type: actions.ADMIN_CLEAR_QUEUE,
  }),
  adminLegacyMatch: (payerUids) => ({
    type: actions.ADMIN_LEGACY_MATCH_REQUEST,
    payload: { payerUids },
  }),
  adminLegacyLookup: (payerUid, query) => ({
    type: actions.ADMIN_LEGACY_LOOKUP_REQUEST,
    payload: { payerUid, query },
  }),
  adminPreviewMigration: (payload) => ({
    type: actions.ADMIN_PREVIEW_MIGRATION_REQUEST,
    payload,
  }),
  adminClearPreviewMigration: () => ({
    type: actions.ADMIN_CLEAR_PREVIEW_MIGRATION,
  }),
  adminMigrateProfile: (payload) => ({
    type: actions.ADMIN_MIGRATE_PROFILE_REQUEST,
    payload,
  }),
  adminClearMigrationResult: () => ({
    type: actions.ADMIN_CLEAR_MIGRATION_RESULT,
  }),
  adminLoadProfileHistory: (profileId) => ({
    type: actions.ADMIN_LOAD_PROFILE_HISTORY_REQUEST,
    payload: { profileId },
  }),
  adminLoadCurrentInvoice: (profileId) => ({
    type: actions.ADMIN_LOAD_CURRENT_INVOICE_REQUEST,
    payload: { profileId },
  }),
  adminClearCurrentInvoices: () => ({
    type: actions.ADMIN_CLEAR_CURRENT_INVOICES,
  }),
  adminSearchAsaasCustomers: (query) => ({
    type: actions.ADMIN_SEARCH_ASAAS_CUSTOMERS_REQUEST,
    payload: { query },
  }),
  adminClearAsaasCustomersSearch: () => ({
    type: actions.ADMIN_CLEAR_ASAAS_CUSTOMERS_SEARCH,
  }),
  adminListUnlinkedProfessionals: ({
    pageSize, cursor, term, reset, onlyMasters, withAccountSummary,
  } = {}) => ({
    type: actions.ADMIN_LIST_UNLINKED_REQUEST,
    payload: {
      pageSize, cursor, term, reset, onlyMasters, withAccountSummary,
    },
  }),
  adminClearUnlinkedProfessionals: () => ({
    type: actions.ADMIN_LIST_UNLINKED_CLEAR,
  }),
};

export default actions;
